import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { ChatPage } from './ChatPage'
import { PlanPage } from './PlanPage'
import { ReportsPage } from './ReportsPage'

export const routes: RouteObject[] = [
  { path: '/ai/chat', element: <ChatPage /> },
  { path: '/ai/reports', element: <ReportsPage /> },
  { path: '/ai/plan', element: <PlanPage /> },
]

// Раздел «ИИ»: голый /ai ведёт на первую вкладку — чат.
const tab = (path: string, label: string, icon: NavItem['icon'], order: number): NavItem => ({
  path,
  label,
  icon,
  mobile: null,
  order,
  parent: '/ai',
})

export const nav: NavItem[] = [
  { path: '/ai', label: 'ИИ', icon: 'ai', mobile: 'more', order: 58 },
  tab('/ai/chat', 'Чат', 'ai', 10),
  tab('/ai/reports', 'Отчёты', 'history', 20),
  tab('/ai/plan', 'Составить план', 'plan', 30),
]
